import React from "react";

export function PhoneListIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="32"
      viewBox="0 0 19 32"
      fill="none"
      {...rest}
    >
      <rect
        x="1"
        y="1"
        width="17"
        height="30"
        rx="2"
        fill="#EFEFEF"
        stroke="#33514A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 19H15"
        stroke="#4BB175"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 23H15"
        stroke="#4BB175"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 27H15"
        stroke="#4BB175"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11H15"
        stroke="#4BB175"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 15H15"
        stroke="#4BB175"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="4" cy="19" r="1" fill="#4BB175" />
      <circle cx="4" cy="23" r="1" fill="#4BB175" />
      <circle cx="4" cy="11" r="1" fill="#4BB175" />
      <circle cx="4" cy="27" r="1" fill="#4BB175" />
      <circle cx="4" cy="15" r="1" fill="#4BB175" />
      <line
        x1="7.82031"
        y1="3.71155"
        x2="11.1775"
        y2="3.71155"
        stroke="#33514A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
